var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { placeholder: "模块类型", filterable: "", clearable: "" },
              model: {
                value: _vm.searchData.type,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "type", $$v)
                },
                expression: "searchData.type"
              }
            },
            _vm._l(_vm.moduleTypeList, function(item, index) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.name, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "厂商名称", clearable: "" },
            model: {
              value: _vm.searchData.productionCompanyName,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "productionCompanyName", $$v)
              },
              expression: "searchData.productionCompanyName"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "型号", clearable: "" },
            model: {
              value: _vm.searchData.moduleCode,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "moduleCode", $$v)
              },
              expression: "searchData.moduleCode"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.fetchHardwareModuleList }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showDialog = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.list,
            stripe: "",
            border: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  prop: item.prop,
                  formatter: item.formatter,
                  label: item.label
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "150", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "编辑", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onClickUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.onClickDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.moduleForm.id ? "编辑" : "新增",
            width: "500px",
            visible: _vm.showDialog,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            },
            close: _vm.onDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "moduleForm",
              attrs: {
                model: _vm.moduleForm,
                rules: _vm.moduleFormRule,
                "label-position": "left",
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "厂商名称编码",
                    required: "",
                    prop: "productionCompanyId"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择厂商名称编码",
                        filterable: "",
                        clearable: ""
                      },
                      model: {
                        value: _vm.moduleForm.productionCompanyId,
                        callback: function($$v) {
                          _vm.$set(_vm.moduleForm, "productionCompanyId", $$v)
                        },
                        expression: "moduleForm.productionCompanyId"
                      }
                    },
                    _vm._l(_vm.companyList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.name + "/" + item.code,
                          value: item.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模块类型", required: "", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.moduleForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.moduleForm, "type", $$v)
                        },
                        expression: "moduleForm.type"
                      }
                    },
                    _vm._l(_vm.typeList, function(item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: item.value,
                          staticStyle: { margin: "0 10px 10px 0" },
                          attrs: { label: item.value, border: "" }
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", title: "新增", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.showType = true
                        }
                      }
                    },
                    [_vm._v("新增")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "模块型号", required: "", prop: "moduleCode" }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请填写模块型号", clearable: "" },
                    model: {
                      value: _vm.moduleForm.moduleCode,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleForm, "moduleCode", $$v)
                      },
                      expression: "moduleForm.moduleCode"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "备注", type: "textarea" },
                    model: {
                      value: _vm.moduleForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.moduleForm, "remark", $$v)
                      },
                      expression: "moduleForm.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("el-button", { on: { click: _vm.onDialogClose } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmitModule }
                    },
                    [_vm._v(_vm._s(_vm.moduleForm.id ? "保存" : "新增"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增模块类型",
            width: "300px",
            visible: _vm.showType,
            center: "",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showType = $event
            },
            close: _vm.onTypeDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "typeForm",
              attrs: { model: _vm.typeForm, rules: _vm.typeFormRule }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模块类型", required: "", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "模块类型名称", clearable: "" },
                    model: {
                      value: _vm.typeForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.typeForm, "name", $$v)
                      },
                      expression: "typeForm.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c("el-button", { on: { click: _vm.onTypeDialogClose } }, [
                    _vm._v("取消")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSubmitType }
                    },
                    [_vm._v(_vm._s(_vm.moduleForm.id ? "保存" : "新增"))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }